import { Component } from "react";
import FieldModal from "../../../../components/modals/fieldModal";
import InputField from "../../../../components/inputs/inputField";
import API from "../../../../utils/API";

class RenamePrinterModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            activeSimpleZebraDevices: [],
            options: [],
            selectedSimpleZebraDevice: null,
            selectedSimpleZebraDeviceFriendlyName: props.printer ? props.printer.friendlyName : '',
            requiredFieldsFilled: false,
        }
    }


    renamePrinter = async () => {
        const { orgId, eventId, toggle, checkInAppConfiguration, printer } = this.props;
        const payload = {
            organizationId: orgId,
            eventId: eventId,
            simpleZebraId: printer._id,
            friendlyName: this.state.selectedSimpleZebraDeviceFriendlyName,
        };

        await API().patch(`/patchActiveZebraPrinter`, payload).then((res) => {
            if (res.data) {
                let updatedActiveSimpleZebraDevices = checkInAppConfiguration.zebraPrinters || [];
                let updatedZebra = res.data.zebraPrinter;
                const existingIndex = updatedActiveSimpleZebraDevices.findIndex(device => device._id === updatedZebra._id);
                if (existingIndex !== -1) {
                    updatedActiveSimpleZebraDevices[existingIndex] = updatedZebra;
                } else {
                    updatedActiveSimpleZebraDevices.push(updatedZebra);
                }
                this.props.updatedActiveSimpleZebraDevices(updatedActiveSimpleZebraDevices);
                toggle();
            }
        });
    }

    render() {
        const { isOpen, toggle, printer } = this.props;
        const { selectedSimpleZebraDeviceFriendlyName, submitting } = this.state;
        let requiredFieldsFilled = false;
        if (selectedSimpleZebraDeviceFriendlyName.trim() !== '') {
            requiredFieldsFilled = true;
        }

        return <div>
            <FieldModal
                size="medium"
                isOpen={isOpen}
                modalTitle={"Rename Printer"}
                bodyHeaderText={''}
                bodyDescription={''}
                bodyContent={() => {
                    return (
                        <div>
                            <InputField
                                label="Friendly Name"
                                value={selectedSimpleZebraDeviceFriendlyName}
                                onChange={(e) => {
                                    this.setState({ selectedSimpleZebraDeviceFriendlyName: e.target.value });
                                }}
                            />
                        </div>)
                }}
                toggle={toggle}
                actionButtonLabel={!submitting ? 'Add ' : 'Adding...'}
                actionButton={() => this.renamePrinter()}
                actionButtonDisabled={submitting || !requiredFieldsFilled}
            ></FieldModal>
        </div>
    }
}

export default RenamePrinterModal;